import XCircleFillIcon from '../../../assets/icons/XCircleFill';

const ViewEmployee = ({ companyInfo, selectedRow, onClose }) => {
  const { name, country_code, phone_number: phone } = selectedRow;
  const employeeInformation = [
    {
        title: 'Company Name',
        value: companyInfo?.name
    },
    {
        title: 'Employee Name',
        value: name
    },
    {
        title: 'Phone Number',
        value: `${country_code} ${phone}`
    }
  ]  
  return (
    <div className='overlay' onClick={onClose}>
      <div className='content_layout' onClick={(e) => e.stopPropagation()}>
        <div className='content_header'>
          <h2>Employee Information</h2>
          <button className='close-btn' onClick={onClose}><XCircleFillIcon size={24} /></button>
        </div>

        <div className="content_body">
          <ul className="info_list">
            {employeeInformation.map((info, index) => (
              <li key={index} className="info_item">
                <span className="info_label">{info.title}:</span>
                <span className="info_value">{info.value}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default ViewEmployee;
